// Module
var code = "<app-shell ng-if=\"useShell && translationsReady\" resolving-route-taking-some-time=\"resolvingRouteTakingSomeTime\" route-animation-classes=\"routeAnimationClasses()\"></app-shell><div ng-if=\"!useShell\"><toast class=\"animated\"></toast><ng-include src=\"'FrontRoyalWrapper/ng_view.html'\"></ng-include></div>";
// Exports
export default code;